<!-- Toolbar with Filter -->
<div class="fw-filter-box animated fadeIn jobs-header">
  <fw-text-input
    leftIcon="filter"
    placeholder="Filter By Gear Name"
    test-id="protenance-tab-filter"
    [formControl]="gearNameFilter"
    [width]="null"
  />

  <!-- Statuses -->
  <div class="job-statuses">
    @if (summary(); as summary) {
      @if (summary.running > 0 || summary.pending > 0) {
        <span>
          <fw-icon
            size="small"
            [ariaLabel]="jobStatusMap['running'].display"
            [color]="jobStatusMap['running'].iconColor"
            [title]="jobStatusMap['running'].display"
            >{{ jobStatusMap['running'].icon }}</fw-icon
          >
          Processing
        </span>
      }
      <span>
        @if (summary.complete > 0) {
          <fw-icon
            size="small"
            [ariaLabel]="jobStatusMap['complete'].display"
            [color]="jobStatusMap['complete'].iconColor"
            [title]="jobStatusMap['complete'].display"
            >{{ jobStatusMap['complete'].icon }}</fw-icon
          >
        }
        {{ summary.complete + ' Jobs Processed' }}
      </span>
      @if (summary.failed > 0) {
        <span>
          <fw-icon
            size="small"
            [ariaLabel]="jobStatusMap['failed'].display"
            [color]="jobStatusMap['failed'].iconColor"
            [title]="jobStatusMap['failed'].display"
            >{{ jobStatusMap['failed'].icon }}</fw-icon
          >
          {{ summary.failed + ' Errors' }}
        </span>
      }
    }
  </div>
  <fw-button test-id="sessions-prov-refresh" (click)="refreshJobs()">Refresh</fw-button>
</div>

<!-- Card -->
@let jobs = displayedJobs();
@if (jobs) {
  @if (jobs.length > 0) {
    <div class="card">
      <table fw-table [dataSource]="jobs">
        <ng-container fwColumnDef="gear">
          <th *fwHeaderCellDef fw-header-cell>Gear</th>
          <td *fwCellDef="let job" class="gear-info" fw-cell test-id="sessions-prov-card">
            <div class="gear-info-wrapper">
              <div class="job-state">
                <span>
                  <fw-icon
                    [ariaLabel]="jobStatusMap[job.state].display"
                    [color]="jobStatusMap[job.state].iconColor"
                    [title]="jobStatusMap[job.state].display"
                    >{{ jobStatusMap[job.state].icon }}</fw-icon
                  >
                </span>
              </div>
              <div class="gear-info-details overflow-ellipsis">
                <strong>{{ job.name }}</strong
                ><br />
                <small class="text-muted"> User: {{ job.origin.type === 'system' ? 'System' : job.origin.id }} </small
                ><br />
                <small class="text-muted"> Updated: {{ job.modified | date: 'M/dd/yyyy H:mm' }} </small><br />
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container fwColumnDef="priority">
          <th *fwHeaderCellDef fw-header-cell>Priority</th>
          <td *fwCellDef="let job" fw-cell test-id="prov-job-priority">
            <span>
              {{ job.priority ? jobPriorityMap[job.priority] : '' }}
            </span>
          </td>
        </ng-container>

        <ng-container fwColumnDef="input">
          <th *fwHeaderCellDef fw-header-cell>Input</th>
          <td *fwCellDef="let job" fw-cell test-id="prov-input-files">
            @for (input of job.inputList | slice: 0 : job.inputLimit; track input) {
              <span class="file-name">
                <fw-ellipsis [text]="$any(input).name" [tooltip]="$any(input).tooltip" />
                @if ($any(input)?.file?.version > 1) {
                  <file-version-badge class="version-badge" [file]="$any(input).file" />
                }
              </span>
            }
            @if (job.inputList.length > 1) {
              <div>
                @if (job.inputLimit <= 1) {
                  <a class="text-muted" test-id="show-more-inputs-link" (click)="job.inputLimit = 5000">
                    <small>{{ 'Show ' + (job.inputList.length - 1) + ' more files' }}</small>
                  </a>
                }
                @if (job.inputLimit > 1) {
                  <a class="text-muted" test-id="hide-inputs-link" (click)="job.inputLimit = 1">
                    <small>Hide</small>
                  </a>
                }
              </div>
            }
          </td>
        </ng-container>

        <ng-container fwColumnDef="output">
          <th *fwHeaderCellDef fw-header-cell>Output</th>
          <td *fwCellDef="let job" fw-cell test-id="prov-output-files">
            @if (job.state === 'failed' && job.retried) {
              <i class="text-muted"> Job has been retried </i>
            }
            @for (output of job.outputList | slice: 0 : job.outputLimit; track output) {
              <span class="file-name">
                <fw-ellipsis [text]="$any(output).name" [tooltip]="$any(output).tooltip" />
                @if ($any(output)?.version > 1) {
                  <file-version-badge class="version-badge" [file]="$any(output)" />
                }
              </span>
            }
            @if (job.outputList.length > 1) {
              <div>
                @if (job.outputLimit <= 1) {
                  <a test-id="show-more-outputs-link" (click)="job.outputLimit = 5000">
                    <small>{{ 'Show ' + (job.outputList.length - 1) + ' more files' }}</small>
                  </a>
                }
                @if (job.outputLimit > 1) {
                  <a test-id="hide-outputs-link" (click)="job.outputLimit = 1">
                    <small>Hide</small>
                  </a>
                }
              </div>
            }
          </td>
        </ng-container>

        <ng-container fwColumnDef="actions">
          <th *fwHeaderCellDef class="actions" fw-header-cell>Actions</th>
          <td *fwCellDef="let job" class="actions" fw-cell>
            @if (isAdmin() && job.state === 'failed' && !job.retried) {
              <fw-button test-id="prov-retry-button" variant="solid" (click)="retryJob(job)">Retry</fw-button>
            }
            @if (isAdmin() && (job.state === 'pending' || job.state === 'running')) {
              <fw-button test-id="prov-cancel-button" variant="solid" (click)="cancelJob(job)">Cancel</fw-button>
            }
            <fw-button test-id="view-log-button" variant="outline" (click)="displayJobLog(job)">View Log</fw-button>
          </td>
        </ng-container>

        <tr *fwHeaderRowDef="displayedColumns" fw-header-row></tr>
        <tr *fwRowDef="let row; columns: displayedColumns" fw-row></tr>
      </table>
      @if (jobs.length < totalJobs()) {
        <fw-button class="load-more" test-id="load-more-jobs-button" variant="outline" (click)="nextPage()">
          Load More
          <small>{{ '0-' + jobs.length + ' of ' + totalJobs() }}</small>
        </fw-button>
      }
    </div>
  } @else {
    <!-- Blank State -->
    <div class="blank-state">
      <fw-icon class="circle-shadow" color="slate" size="large">settings-gear</fw-icon>
      <p>No jobs have run!</p>
      <fw-button test-id="refresh-jobs-button" variant="solid" (click)="refreshJobs()">Refresh</fw-button>
    </div>
  }
} @else {
  <!-- Loading State -->
  <div class="blank-state">
    <img src="/assets/images/loading.svg" style="margin-bottom: 10px" />
    <p>Loading jobs...</p>
  </div>
}
